import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';

const SettingsPage = () => {
  const { user } = useAuth();
  const [profile, setProfile] = useState({ name: '', email: '' });
  const [passwords, setPasswords] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get('/auth/me').then(res => setProfile({ name: res.data.name, email: res.data.email })).catch(() => {});
    if (user.role === 'admin') {
      api.get('/auth/users').then(res => setUsers(res.data)).catch(() => {});
    }
  }, [user.role]);

  const updateProfile = async (e) => {
    e.preventDefault();
    try {
      await api.put('/auth/profile', profile);
      toast.success('Profile updated');
    } catch (err) { toast.error('Update failed'); }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    if (passwords.newPassword !== passwords.confirmPassword) {
      return toast.error('Passwords do not match');
    }
    try {
      await api.put('/auth/change-password', { currentPassword: passwords.currentPassword, newPassword: passwords.newPassword });
      toast.success('Password changed');
      setPasswords({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) { toast.error(err.response?.data?.message || 'Password change failed'); }
  };

  const changeRole = async (userId, role) => {
    try {
      await api.put(`/auth/users/${userId}/role`, { role });
      toast.success('Role updated');
      const res = await api.get('/auth/users');
      setUsers(res.data);
    } catch (err) { toast.error('Role update failed'); }
  };

  return (
    <div className="settings-page">
      <h1>Settings</h1>

      <div className="form-card">
        <h3>Profile</h3>
        <form onSubmit={updateProfile}>
          <div className="form-grid">
            <div className="form-group"><label>Name</label><input value={profile.name} onChange={e => setProfile({ ...profile, name: e.target.value })} /></div>
            <div className="form-group"><label>Email</label><input type="email" value={profile.email} onChange={e => setProfile({ ...profile, email: e.target.value })} /></div>
          </div>
          <button type="submit" className="btn-primary" style={{ marginTop: '1rem' }}>Update Profile</button>
        </form>
      </div>

      <div className="form-card" style={{ marginTop: '1.5rem' }}>
        <h3>Change Password</h3>
        <form onSubmit={changePassword}>
          <div className="form-grid">
            <div className="form-group"><label>Current Password</label><input type="password" value={passwords.currentPassword} onChange={e => setPasswords({ ...passwords, currentPassword: e.target.value })} required /></div>
            <div className="form-group"><label>New Password</label><input type="password" value={passwords.newPassword} onChange={e => setPasswords({ ...passwords, newPassword: e.target.value })} required /></div>
            <div className="form-group"><label>Confirm Password</label><input type="password" value={passwords.confirmPassword} onChange={e => setPasswords({ ...passwords, confirmPassword: e.target.value })} required /></div>
          </div>
          <button type="submit" className="btn-primary" style={{ marginTop: '1rem' }}>Change Password</button>
        </form>
      </div>

      {user.role === 'admin' && (
        <div className="form-card" style={{ marginTop: '1.5rem' }}>
          <h3>Role Management</h3>
          <table className="table">
            <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Action</th></tr></thead>
            <tbody>
              {users.map(u => (
                <tr key={u._id}>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td><span className={`status-badge status-${u.role}`}>{u.role}</span></td>
                  <td>
                    <select value={u.role} onChange={e => changeRole(u._id, e.target.value)}>
                      <option value="employee">Employee</option>
                      <option value="hr">HR</option>
                      <option value="admin">Admin</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SettingsPage;
